module.exports = __webpack_public_path__ + "static/media/landing_pattern_bg_conversational.4036fe25.png";